import useWebRTCStream from './useWebRTCStream';

export default useWebRTCStream;
